import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'issue',
      title: 'Issue New Credential',
      description: 'Create and issue verifiable credentials with custom templates',
      icon: 'FileText',
      color: 'bg-primary',
      route: '/credential-issuance',
      stats: '12 templates available'
    },
    {
      id: 'verify',
      title: 'Verify Credential',
      description: 'Validate authenticity using QR codes or manual input',
      icon: 'Shield',
      color: 'bg-success',
      route: '/credential-verification',
      stats: '3 pending verifications'
    },
    {
      id: 'wallet',
      title: 'Manage Wallet',
      description: 'Organize and control your digital credential collection',
      icon: 'Wallet',
      color: 'bg-accent',
      route: '/digital-wallet',
      stats: '24 credentials stored'
    }
  ];

  const handleActionClick = (route) => {
    navigate(route);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Quick Actions</h2>
        <div className="flex items-center space-x-2">
          <Icon name="Zap" size={16} className="text-warning" />
          <span className="text-sm text-muted-foreground">Fast access</span>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {quickActions?.map((action) => (
          <div key={action?.id} className="group relative">
            <button
              onClick={() => handleActionClick(action?.route)}
              className="w-full text-left p-4 border border-border rounded-lg hover:shadow-md hover:border-primary/20 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              <div className="flex items-start space-x-4">
                <div className={`${action?.color} p-3 rounded-lg flex-shrink-0 group-hover:scale-105 transition-transform duration-200`}>
                  <Icon name={action?.icon} size={24} color="white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground mb-1 group-hover:text-primary transition-colors">
                    {action?.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
                    {action?.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-muted-foreground">{action?.stats}</span>
                    <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-200" />
                  </div>
                </div>
              </div>
            </button>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">Recent activity</span>
          </div>
          <Button variant="ghost" size="sm" onClick={() => navigate('/privacy-settings')}>
            <Icon name="Settings" size={16} className="mr-2" />
            Settings
          </Button>
        </div>
        
        <div className="mt-3 space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Last credential issued</span>
            <span className="text-foreground">2 hours ago</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Last verification</span>
            <span className="text-foreground">45 minutes ago</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Wallet last synced</span>
            <span className="text-success">Just now</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsPanel;